import { render, staticRenderFns } from "./StatementIndex.vue?vue&type=template&id=1aab169c"
import script from "./StatementIndex.vue?vue&type=script&lang=js"
export * from "./StatementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aab169c')) {
      api.createRecord('1aab169c', component.options)
    } else {
      api.reload('1aab169c', component.options)
    }
    module.hot.accept("./StatementIndex.vue?vue&type=template&id=1aab169c", function () {
      api.rerender('1aab169c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/fees/StatementIndex.vue"
export default component.exports